<template>
  <div
    v-for="(node, index) in nodes"
    :key="index"
    :class="readOnly ? 'xmb-2' : 'lp-tree-item'"
    role="treeitem"
    :aria-selected="!!node.checked"
    v-memo="[
      readOnly,
      node.isExpanded,
      node.checked,
      isMouseEnter,
      computed(() => isIndeterminate(node)),
    ]"
  >
    <div
      class="d-flex ly-start-center row"
      :class="[
        !node.children.length && 'lp-tree-item-single',
        readOnly ? 'xmb-1' : 'lp-tree-item-inner',
      ]"
      @mouseenter="handleIsMouseEnter(index)"
      @mouseleave="handleIsMouseEnter(null)"
    >
      <lp-button
        v-if="node.hasChildren"
        :icon="node.isExpanded ? 'caret-down' : 'caret-right'"
        text
        :size="readOnly ? Sizes.XSMALL : Sizes.SMALL"
        @click="node.isExpanded = !node.isExpanded"
      />
      <lp-button
        v-if="readOnly"
        :label="String(node.label)"
        text
        :size="Sizes.XSMALL"
        class="lp-tree-read-only-item xmx-0"
        @click="handleNodeSelect(node)"
      />
      <lp-button
        v-if="readOnly && node.value"
        :label="formatNodeValue(node.value).toString()"
        :size="Sizes.XSMALL"
        text
        class="text-black-40 xmx-1"
        @click="handleNodeSelect(node)"
      />
      <lp-checkbox
        v-if="!readOnly"
        v-model="node.checked"
        :label="String(node.label)"
        :indeterminate="node.children.length ? isIndeterminate(node) : false"
        @update:model-value="
          node.children.length && toggleChildren(node, node.checked)
        "
      />
    </div>
    <div
      v-show="node.isExpanded"
      class="row"
      :class="readOnly ? 'xml-4 xmt-2' : 'lp-tree-item-parent'"
    >
      <div class="lp-tree">
        <lp-tree-node
          v-if="node.children.length"
          :children="node.children"
          :read-only="readOnly"
          @node-select="handleNodeSelect"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
export default {
  name: 'lp-tree-node',
}
</script>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { Sizes } from '@/models/enums'
import LpButton from '@/components/button'
import {
  toggleChildren,
  isIndeterminate,
  formatNodeValue,
} from '@/components/tree/utils'

interface Props {
  children: Record<string, unknown>[] | null
  disabled?: boolean
  readOnly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  children: null,
  disabled: false,
  readOnly: false,
})

const emit = defineEmits(['node-select'])

const handleNodeSelect = (e: string, copyValue = false) => {
  emit('node-select', e, copyValue)
}
const nodes = ref(props.children)
const isMouseEnter = ref()
const handleIsMouseEnter = (value: number | null) => {
  isMouseEnter.value = value
}
</script>
<style scoped>
.row {
  :deep(& > button) {
    margin-right: 0.5rem;
  }
}
</style>
